import { observable, flow, action, computed } from 'mobx';
import { ajax } from '@clouderwork/ywk';
import { IBaseData } from '../../entity/user';
// import { IMembers } from "./project";
import { IMembersSel } from '@src/entity/company/project';
import { urlFn } from '@src/utils';
import { Toast } from 'antd-mobile';
import { companyMember2Memberssel } from '@src/utils/mapping';
import { toLogin } from '@src/utils/helper';

export interface IMember extends IMembersSel {
  id: string;
  logo: string;
  user_name: string;
  user_uuid: string;
}

interface ICompany {
  entityName: string;
  entityDesc: string;
  entityLogoUuid: string;
  entityHeadPicUuid: string | null;
  verifyStatus: number;
  industry1: string;
  industry2: string;
  stuffsType: number;
  region: string;
  uuid: string;
  creator: string;
  createAt: string;
  updator: string;
  updateAt: string;
  entityLogoUrl: string;
  entityHeadPicUrl: string | null;
  entityActivated: number;
  userUuid: string | null;
  entityUuid: string | null;
  staffCount: number;
  linkmanCount: number;
  deptCount: number;
  leader: string;
}

export default class User {
  @observable user: any = {};
  @observable activeCompany: ICompany | undefined;
  @observable baseData: IBaseData = {};
  @observable members: IMembersSel[] = [];
  @observable memberStatus: string = 'init';

  constructor() {
    const flag = urlFn.getFirstPathName();
    if (flag !== 'company') return;
    console.log('company user constructor');
    this.getInfo();
    this.getParams();
    this.getActiveCompany();
  }
  @action.bound
  getInfo = flow(function* (this: User) {
    try {
      const res = yield ajax.getJson('/company/api/user/profile');
      if (+res.error_code === 0) {
        this.user = res.result;
        window.AnalysysAgent.alias(`${this.user.uuid}`);
      } else {
        console.log('res.response>>>>>:', res.response);
        if (res.response && res.response.data) {
          const href = window.location.href;
          if (
            href.includes('company/legal') ||
            href.includes('company/privacy') ||
            href.includes('company/appprivacy') ||
            href.includes('company/applegal') ||
            href.includes('company/jzst-applegal') ||
            href.includes('company/jzst-privacy') ||
            href.includes('company/filepreview') ||
            href.includes('company/appdownload')
          ) {
          } else {
            Toast.fail(res.response.data.msg, 1);
            // 未登录
            if (res.response.status === 403 || (res.response.data && +res.response.data.error_code === 80001)) {
              toLogin();
              return;
            }
          }
        }
      }
      return res;
    } catch (error) {
      return error;
    }
  });

  @action.bound
  getParams = flow(function* (this: User) {
    // 获取基础数据
    try {
      const res = yield ajax.getJson('/company/api/params');
      if (+res.error_code === 0) {
        this.baseData = res.result;
      }
    } catch (error) {}
  });
  @action.bound
  getActiveCompany = flow(function* (this: User) {
    // 获取基础数据
    try {
      const res = yield ajax.getJson('/company/api/users/companys/active');
      if (+res.error_code === 0) {
        this.activeCompany = res.result;
      }
    } catch (error) {}
  });

  /**
   * 是否有下属的项目
   */
  @computed get managed() {
    // console.log('this.user', this.user, this.user && this.user.has_staff);
    return this.user && this.user.has_staff;
  }
  /**
   * 获取公司成员
   */
  @action.bound
  getCompanyMembers = flow(function* (this: User) {
    this.memberStatus = 'pending';
    try {
      const res1 = yield ajax.getJson('/company/api/company/users', { memberType: '1,2' });
      const res2 = yield ajax.getJson('/company/api/company/users', { memberType: '3,4,5' });
      this.memberStatus = 'done';
      if (+res1.error_code === 0 && +res2.error_code === 0) {
        this.members = companyMember2Memberssel([...res1.result, ...res2.result]) as IMembersSel[];
      }
      return res2;
    } catch (error) {
      this.memberStatus = 'error';
      return error;
    }
  });
}
